import { PlantValidationResponse } from '../plants';
import { useApi } from '../';

export function usePageValidationsService() {
    const { get } = useApi();
    const baseApi = `/v2/plants`;

    const getValidations = async (plantId?: string): Promise<PlantValidationResponse> => {
        const { data } = await get<PlantValidationResponse>(`${baseApi}/${plantId}/validations`);

        return data;
    };

    return {
        getValidations
    };
}
